import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import favicon_nav from '../img/favicon_nav.png';

const sunIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>;
const moonIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>;
const homeIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>;

const browserInDarkMode = (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches));

export default function Header() {
  let location = useLocation();
  let currentPath = location.pathname;
  let atLanding = currentPath === '/';

  // manage state of dark/light theme toggle icon (sun/moon)
  const [isDarkMode, setDarkModeIcon] = useState(browserInDarkMode);

  // toggle dark mode, see https://tailwindcss.com/docs/dark-mode
  function toggleDarkMode() {
    if (localStorage.theme === 'dark') {
      localStorage.theme = 'light';
      document.documentElement.classList.remove('dark');
      setDarkModeIcon(false);
    } else {
      localStorage.theme = 'dark';
      document.documentElement.classList.add('dark');
      setDarkModeIcon(true);
    }
  }

  let HomeButton;
  let BrandIcon;
  if (atLanding) {
    // on landing page, neither navigation icons have interactivity as they do nothing
    HomeButton = (
      <div className="flex flex-row items-center gap-x-2 ml-5">
        <button className="cursor-default">{homeIcon}</button>
      </div>
    );
    BrandIcon = (
      <img className="h-18 w-8" src={favicon_nav} alt="navicon" />
    );
  } else {
    // add a link and an indicator arrow for navigation on other pages
    let routeSplit = currentPath.split('/');
    let currentRoute = routeSplit[routeSplit.length - 1];
    let prevRouteText = currentRoute.toUpperCase().replace("-", " ");
    HomeButton = (
      <div className="flex flex-row items-center text-xl">
          {prevRouteText}
      </div>
    );
    BrandIcon = (
      <Link to="/">
        <img className="brand-icon h-18 w-8 ring-2 ring-blue-500" src={favicon_nav} alt="navicon" />
      </Link>
    );
  }
  return (
    <header className="flex flex-row items-center p-2 sm:p-8 h-14 mb-4 header-footer border-b">
      <div className="basis-1/3 flex justify-start">
        <button>
          {BrandIcon}
        </button>
      </div>
      <div className="basis-1/3 flex justify-center">
        {HomeButton}
      </div>
      <div className="basis-1/3 flex justify-end">
        <button className="day-night-button self-end"
          onClick={() => { toggleDarkMode(); }}
        >{isDarkMode ? sunIcon : moonIcon}</button>
      </div>
    </header>
  );
}